function generateId() {
    return (Math.random() * 100000000).toFixed();
}

export { generateId as default };
